import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    event: String,
    estimationType: { type: String, default: "tarifaire" },
    payload: Object,
    trackOnConnect: Boolean,
    clickText: String,
  }

  connect() {
    if (this.trackOnConnectValue) {
      this.track();
    }
  }

  trackOnClick(event) {
    if (event.target.textContent === this.clickTextValue) {
      this.track();
    }
  }

  track() {
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: this.eventValue,
      estimation_type: this.estimationTypeValue,
      ...this.payloadValue,
    });
  }
}
